import React, { useCallback, useEffect, useState } from "react";
import { adminApi } from "./adminApi";

export default function AdminMarkets() {
    const [data, setData] = useState({ items: [], total_located: 0 });
    const [loading, setLoading] = useState(true);

    const load = useCallback(async () => {
        setLoading(true);
        setData(await adminApi.markets());
        setLoading(false);
    }, []);

    useEffect(() => { load(); }, [load]);

    return (
        <div className="p-10 max-w-4xl" data-testid="admin-markets">
            <span className="text-[10px] tracking-[0.36em] uppercase text-gold-deep">Demand</span>
            <h1 className="mt-2 font-display text-5xl text-burgundy">
                <span className="italic">Market</span> ranking
            </h1>
            <p className="mt-3 text-sm text-ink-muted max-w-lg">
                Metro areas ranked by signup demand. Launch markets in the order members show up.
            </p>
            <div className="mt-4 text-xs tracking-[0.28em] uppercase text-ink-muted" data-testid="markets-total">
                {data.total_located} located members
            </div>

            <div className="mt-6 border border-burgundy/15 bg-cream overflow-hidden">
                <table className="w-full text-sm">
                    <thead className="bg-cream-soft text-[10px] tracking-[0.28em] uppercase text-ink-muted">
                        <tr>
                            <th className="text-left px-4 py-3 w-12">#</th>
                            <th className="text-left px-4 py-3">Metro area</th>
                            <th className="text-right px-4 py-3">Signups</th>
                            <th className="text-right px-4 py-3">With email</th>
                            <th className="text-right px-4 py-3">Founding</th>
                        </tr>
                    </thead>
                    <tbody>
                        {loading && (
                            <tr><td colSpan={5} className="px-4 py-10 text-center text-ink-muted">Loading…</td></tr>
                        )}
                        {!loading && data.items.length === 0 && (
                            <tr><td colSpan={5} className="px-4 py-10 text-center text-ink-muted">No located members yet.</td></tr>
                        )}
                        {data.items.map((m, i) => (
                            <tr key={m.metro_area} className="border-t border-burgundy/10" data-testid={`market-row-${i}`}>
                                <td className="px-4 py-3 text-ink-muted">{i + 1}</td>
                                <td className="px-4 py-3 font-display text-base text-burgundy">{m.metro_area}</td>
                                <td className="px-4 py-3 text-right font-medium">{m.signups}</td>
                                <td className="px-4 py-3 text-right text-ink-muted">{m.with_email}</td>
                                <td className="px-4 py-3 text-right text-ink-muted">{m.founding}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}
